import { BackgroundEffectGroups } from '../types';
export const BrandedVirtualBackground = {
    index: 2,
    group: BackgroundEffectGroups.noEffectsBlur,
    name: 'Branded',
    filter: { type: 'backgroundBlur', blurStrength: 'high' },
    metadata: {
        title: 'backgroundEffects.options.branded',
        label: 'backgroundEffects.options.branded',
        icon: '/assets/images/backgrounds/branded.svg',
    },
};
export const defaultBackgroundEffects = [
    {
        index: 0,
        group: BackgroundEffectGroups.noEffectsBlur,
        name: 'None',
        filter: null,
        metadata: {
            title: 'backgroundEffects.options.none',
            label: 'backgroundEffects.options.none',
            icon: '/assets/images/backgrounds/none.svg',
        },
    },
    {
        index: 1,
        group: BackgroundEffectGroups.noEffectsBlur,
        name: 'Slight Blur',
        filter: { type: 'backgroundBlur', blurStrength: 'low' },
        metadata: {
            title: 'backgroundEffects.options.slightBlur',
            label: 'backgroundEffects.options.slightBlur',
            icon: '/assets/images/backgrounds/blur-low.svg',
        },
    },
    {
        index: 2,
        group: BackgroundEffectGroups.noEffectsBlur,
        name: 'Blur',
        filter: { type: 'backgroundBlur', blurStrength: 'high' },
        metadata: {
            title: 'backgroundEffects.options.blur',
            label: 'backgroundEffects.options.blur',
            icon: '/assets/images/backgrounds/blur.svg',
        },
    },
    {
        index: 3,
        group: BackgroundEffectGroups.office,
        name: 'Classic office with brown couch',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/officehome1.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.officehome1',
            thumbnail: '/assets/images/backgrounds/officehome1.thumbnail.webp',
        },
    },
    {
        index: 4,
        group: BackgroundEffectGroups.office,
        name: 'Living room with large windows',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/officehome2.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.officehome2',
            thumbnail: '/assets/images/backgrounds/officehome2.thumbnail.webp',
        },
    },
    {
        index: 5,
        group: BackgroundEffectGroups.office,
        name: 'Office with couch and plants',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/officehome3.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.officehome3',
            thumbnail: '/assets/images/backgrounds/officehome3.thumbnail.webp',
        },
    },
    {
        index: 18,
        group: BackgroundEffectGroups.office,
        name: 'Rustic office with desk',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/officehome4.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.officehome4',
            thumbnail: '/assets/images/backgrounds/officehome4.thumbnail.webp',
        },
    },
    {
        index: 19,
        group: BackgroundEffectGroups.office,
        name: 'Brown bookshelves',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/officehome5.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.officehome5',
            thumbnail: '/assets/images/backgrounds/officehome5.thumbnail.webp',
        },
    },
    {
        index: 20,
        group: BackgroundEffectGroups.office,
        name: 'White bookshelves',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/officehome6.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.officehome6',
            thumbnail: '/assets/images/backgrounds/officehome6.thumbnail.webp',
        },
    },
    {
        index: 6,
        group: BackgroundEffectGroups.medical,
        name: 'Wide open office with large window',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/medical1.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.medical1',
            thumbnail: '/assets/images/backgrounds/medical1.thumbnail.webp',
        },
    },
    {
        index: 21,
        group: BackgroundEffectGroups.medical,
        name: 'Medical exam room in rural setting',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/medical2.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.medical2',
            thumbnail: '/assets/images/backgrounds/medical2.thumbnail.webp',
        },
    },
    {
        index: 22,
        group: BackgroundEffectGroups.medical,
        name: 'Medical exam room in urban setting',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/medical3.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.medical3',
            thumbnail: '/assets/images/backgrounds/medical3.thumbnail.webp',
        },
    },
    {
        index: 7,
        group: BackgroundEffectGroups.outdoor,
        name: 'Beachside patio with sunset',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/outdoor1.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.outdoor1',
            thumbnail: '/assets/images/backgrounds/outdoor1.thumbnail.webp',
        },
    },
    {
        index: 8,
        group: BackgroundEffectGroups.outdoor,
        name: 'River valley with large tree',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/outdoor2.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.outdoor2',
            thumbnail: '/assets/images/backgrounds/outdoor2.thumbnail.webp',
        },
    },
    {
        index: 23,
        group: BackgroundEffectGroups.outdoor,
        name: 'River with green rolling hills',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/outdoor3.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.outdoor3',
            thumbnail: '/assets/images/backgrounds/outdoor3.thumbnail.webp',
        },
    },
    {
        index: 24,
        group: BackgroundEffectGroups.outdoor,
        name: 'Mountain lake',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/outdoor4.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.outdoor4',
            thumbnail: '/assets/images/backgrounds/outdoor4.thumbnail.webp',
        },
    },
    {
        index: 25,
        group: BackgroundEffectGroups.outdoor,
        name: 'Mountainous setting',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/outdoor5.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.outdoor5',
            thumbnail: '/assets/images/backgrounds/outdoor5.thumbnail.webp',
        },
    },
    {
        index: 9,
        group: BackgroundEffectGroups.simple,
        name: 'Creme colored design',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/simple1.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.simple1',
            thumbnail: '/assets/images/backgrounds/simple1.thumbnail.webp',
        },
    },
    {
        index: 10,
        group: BackgroundEffectGroups.simple,
        name: 'Peach colored design',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/simple2.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.simple2',
            thumbnail: '/assets/images/backgrounds/simple2.thumbnail.webp',
        },
    },
    {
        index: 11,
        group: BackgroundEffectGroups.simple,
        name: 'Beige colored design',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/simple3.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.simple3',
            thumbnail: '/assets/images/backgrounds/simple3.thumbnail.webp',
        },
    },
    {
        index: 15,
        group: BackgroundEffectGroups.simple,
        name: 'Red and white wavy design',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/simple4.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.simple4',
            thumbnail: '/assets/images/backgrounds/simple4.thumbnail.webp',
        },
    },
    {
        index: 16,
        group: BackgroundEffectGroups.simple,
        name: 'Gray wall with flowers',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/simple5.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.simple5',
            thumbnail: '/assets/images/backgrounds/simple5.thumbnail.webp',
        },
    },
    {
        index: 17,
        group: BackgroundEffectGroups.simple,
        name: 'Blue wall with chair',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/simple6.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.simple6',
            thumbnail: '/assets/images/backgrounds/simple6.thumbnail.webp',
        },
    },
    {
        index: 12,
        group: BackgroundEffectGroups.fun,
        name: 'Cartoon city street',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/playful1.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.playful1',
            thumbnail: '/assets/images/backgrounds/playful1.thumbnail.webp',
        },
    },
    {
        index: 13,
        group: BackgroundEffectGroups.fun,
        name: 'Candy castle',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/playful2.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.playful2',
            thumbnail: '/assets/images/backgrounds/playful2.thumbnail.webp',
        },
    },
    {
        index: 14,
        group: BackgroundEffectGroups.fun,
        name: 'Colorful mushroom world',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/playful3.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.playful3',
            thumbnail: '/assets/images/backgrounds/playful3.thumbnail.webp',
        },
    },
    {
        index: 26,
        group: BackgroundEffectGroups.fun,
        name: 'Underwater world',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/playful4.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.playful4',
            thumbnail: '/assets/images/backgrounds/playful4.thumbnail.webp',
        },
    },
    {
        index: 27,
        group: BackgroundEffectGroups.fun,
        name: 'Spaceship control room',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/playful5.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.playful5',
            thumbnail: '/assets/images/backgrounds/playful5.thumbnail.webp',
        },
    },
    {
        index: 28,
        group: BackgroundEffectGroups.fun,
        name: 'Outer space with planets',
        filter: {
            type: 'backgroundReplacement',
            backgroundImgUrl: '/assets/images/backgrounds/playful6.jpg',
        },
        metadata: {
            title: 'backgroundEffects.options.playful6',
            thumbnail: '/assets/images/backgrounds/playful6.thumbnail.webp',
        },
    },
];
/**
 * (Temporary) Returns the default background effects with the branded virtual background effect
 * inserted at the third position. Removes the "Slight blur" background effect.
 */
export const getEffectsWithBrandedVirtualBackground = () => {
    const [none, _slightBlur, blur, ...rest] = defaultBackgroundEffects;
    const reorderedEffects = [
        none,
        { ...blur, index: 1 },
        BrandedVirtualBackground,
        ...rest,
    ];
    return reorderedEffects;
};
